import orderBy from 'lodash/orderBy'
import keys from 'lodash/keys'

export const serializeObject = obj => {
  const sortedKeys = orderBy(keys(obj), key => key.toLowerCase())
  const values = sortedKeys.map(key => `${key}:${obj[key]}`)
  return values.join('-')
}
